import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { GetSynevoReportCompanyDto } from '../../../common/spdCore/autogenerated/spdApiClient';

interface ReportSynevoCompaniesSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick?: (key: string) => Promise<void> | void | undefined;
  refresh?: boolean;
  enableSingleSelect?: boolean;
  selectedKeys?: string[];
}

export const reportSynevoCompanyForGrid = (
  reportCompany: GetSynevoReportCompanyDto,
  // dateFrom?: Date,
  // dateTo?: Date,
) => {
  return {
    key: reportCompany.id,
    values: {
      company_name: reportCompany.companyName,
      sed_name: reportCompany.supportingExaminationDictName || '',
      synevo_code: reportCompany.synevoCode,
      synevoCount: reportCompany.countSynevo,
      // details: (
      //   <ReportCompaniesDetails
      //     companyId={reportCompany.companyId}
      //     registerId={reportCompany.registerId}
      //     healthcareFacilityId={reportCompany.healthcareFacilityId}
      //     dateFrom={dateFrom}
      //     dateTo={dateTo}
      //     onlyMonthlySettlement={onlyMonthlySettlement}
      //   />
      // ),
    },
  };
};

export const ReportSynevoCompaniesSearch: React.FC<
  ReportSynevoCompaniesSearchProps
> = props => {
  const columns = [
    { header: 'Firma', property: 'company_name' },
    { header: 'Badanie pomocnicze', property: 'sed_name' },
    { header: 'Kod Synevo', property: 'synevo_code' },
    {
      header: 'Liczba zrealizowanych zleceń Synevo',
      property: 'synevoCount',
      noSorting: true,
    },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      initialOrderColumn="company_name, sed_name"
      initialOrderDirection="ASC"
      availablePageSizes={[10, 20, 50]}
      pageSize={20}
      onRowClick={props.onRowClick}
      emptyGridMessage="Brak zrealizowanych zleceń synevo w systemie"
      refresh={props.refresh}
      enableSingleSelect={props.enableSingleSelect}
      selectedKeys={props.selectedKeys}
      showExport={true}
    />
  );
};
